import React from 'react'
import {ExperienceCard} from '../components'
import { motion } from 'framer-motion'
import { experience } from '../constants'

export default function Experience() {
  return (
    <motion.div 
    initial={{opacity:0}}
    whileInView={{opacity:1}}
    transition={{duration:1.5}}
    className="h-screen flex relative flex-col text-center md:text-left xl:flex-row max-w-[2000px]  min-h-screen justify-center mx-auto items-center">
        <h3 className='absolute md:top-20 top-24 uppercase tracking-[20px] text-gray-500 text-2xl'>
          Experience
        </h3>
        
        <div className='w-full flex space-x-5 mt-20 items-center justify-center overflow-x-hidden p-10 snap-x snap-mandatory scrollbar-thin scrollbar-thumb-[#F7AB0A]/80 scrollbar-track-gray-400/20'>
          {experience.map((item) => (
            <ExperienceCard {...item}/>
          ))}
          
        </div>
    </motion.div>
  )
}